(() => {
    if (document.body.getAttribute('data-page-template') == 'product' || document.body.getAttribute('data-page-template') == 'product.bundle-page') {
        let urlString = window.location.href;
        let url = new URL(urlString);
        let variantId = url.searchParams.get("variant");
        let activeVariant;
        let bundleSize;

        function zoomIn(e){
            var zoomer = e.currentTarget;
            e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
            e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
            x = offsetX/zoomer.offsetWidth*100
            y = offsetY/zoomer.offsetHeight*100

            if (!zoomer.style.backgroundImage) {
                zoomer.style.backgroundImage = 'url('+zoomer.getAttribute('data-bg')+')';
            }
            zoomer.style.backgroundPosition = x + '% ' + y + '%';
        }

        function zoomOut(e){
            var zoomer = e.currentTarget;
            zoomer.style.backgroundImage = '';
        }

        window.theme.product_json_data.length
            ? window.theme.product_json_data.forEach((product) => {
                product.variants.find((variant) => {
                    if (variant.id == variantId) activeVariant = variant;
                });
            })
            : window.theme.product_json_data.variants.find((variant) => {
                if (variant.id == variantId) activeVariant = variant;
            });

        if (activeVariant) {
            let activeCurrency = window.Shopify.currency.active ?? 'USD'
            let price = activeVariant.price / 100;
            let priceFormatted = price.toLocaleString("en-US", {style:"currency", currency: activeCurrency});
            bundleSize = activeVariant.title.includes('Double')
                ? 2
                : parseInt(activeVariant.title);

            let pricePerUnit = parseFloat(price / bundleSize, 2);
            let pricePerUnitFormatted = pricePerUnit.toLocaleString("en-US", {style:"currency", currency: activeCurrency});

            document.querySelector('meta[property="og:price:amount"]').setAttribute('content',price );

            document.querySelectorAll('.ProductCoreForm__price').forEach((item)=> {
                let currentTitle = item.querySelector('.ProductCoreForm__h4Title');
                currentTitle.innerHTML = priceFormatted;

                if (!activeVariant.title.includes('Single')) {
                    currentTitle.setAttribute('data-price-per-unit', '('+pricePerUnitFormatted+' / unit)');
                }
            })

            if (!activeVariant.title.includes('Single')) {
                document.querySelectorAll('.ProductCoreForm__h1Title').forEach((title) => {
                    title.innerHTML += ` - ${activeVariant.title}`;
                })
            }

            if (!activeVariant.title.includes('Double') && !activeVariant.title.includes('Single')) {
                let slideItem = document.createElement("div");
                let slideItemContent = `<div class="ContainedImage"><div class="ContainedImage__aspectPadding" style="padding-top:100%"><div class="ContainedImage__absolutePosition"><div class="ContainedImage__imgWrapper ContainedImage__imgWrapper--zoom" data-bg="${ activeVariant.featured_image.src }"><img class="ContainedImage__img lazyautosizes lazyloaded" src="${ activeVariant.featured_image.src }"></div></div></div></div>`;
                slideItem.classList.add('ProductCoreMedia__singleImageCell');
                slideItem.classList.add('carousel-cell');
                slideItem.innerHTML += slideItemContent;

                let zoomImg = slideItem.querySelector('.ContainedImage__imgWrapper--zoom');

                zoomImg.addEventListener('mousemove', function (e) {
                    zoomIn(e)
                });
                zoomImg.addEventListener('mouseout', function (e) {
                    zoomOut(e)
                });

                window.flick_bundle_instance.prepend(slideItem);
                window.flick_bundle_instance.select(0, false, true);


                if (window.flick_thumbs_instance) {
                    let thumbItem = document.createElement("div");
                    let thumbItemContent = `<div class="ProductCoreMedia__thumbnailsSingleImageCellContained"><div class="ContainedImage"><div class="ContainedImage__aspectPadding" style="padding-top:100%"><div class="ContainedImage__absolutePosition"><div class="ContainedImage__imgWrapper"><img class="ContainedImage__img" src="${ activeVariant.featured_image.src }"></div></div></div></div></div>`;
                    thumbItem.classList.add('ProductCoreMedia__thumbnailsSingleImageCell');
                    thumbItem.classList.add('carousel-cell');

                    thumbItem.innerHTML += thumbItemContent;

                    window.flick_thumbs_instance.prepend(thumbItem);
                    window.flick_thumbs_instance.select(0, false, true);
                } else {
                    let thumbItem = document.createElement("div");
                    let thumbItemContent = `<div class="ProductCoreMedia__thumbnailsSingleImageCellContained"><div class="ContainedImage"><div class="ContainedImage__aspectPadding" style="padding-top:100%"><div class="ContainedImage__absolutePosition"><div class="ContainedImage__imgWrapper"><img class="ContainedImage__img" src="${ activeVariant.featured_image.src }"></div></div></div></div></div>`;
                    thumbItem.classList.add('ProductCoreMedia__thumbnailsSingleImageCell');
                    thumbItem.classList.add('carousel-cell');

                    thumbItem.innerHTML += thumbItemContent;

                    let thumbnails = document.querySelector('.ProductCoreMedia__thumbnails');

                    thumbnails.prepend(thumbItem);

                    thumbnails.querySelectorAll('.carousel-cell').forEach((cell, index) => {
                        if (index == 0) {
                            cell.classList.add('state-active');
                        } else {
                            cell.classList.remove('state-active');
                        }

                        cell.setAttribute('data-index', index+1);
                    })
                }
            }
        }
    }

    const priceSelects = document.querySelectorAll('.c-stages-items .SelectedProductBundles__selectInput').length
        ? document.querySelectorAll('.c-stages-items .SelectedProductBundles__selectInput')
        : document.querySelectorAll('.SelectedProductBundles__form .SelectedProductBundles__selectInput');

    if (priceSelects) {
        priceSelects.forEach((select) => {
            select.querySelectorAll('option').forEach((option) => {
                // let currentPrice = option.getAttribute('data-price');
                let variantTitle = option.getAttribute('data-variant-title').toLowerCase();
                // currentPrice = parseInt(currentPrice / window.Shopify.currency.rate);
                let freeShippingAttribute = option.getAttribute('data-free-shipping');
                if (freeShippingAttribute === 'false') {
                    return;
                }

                if (freeShippingAttribute === 'true' || !/3 pack|double pack/.test(variantTitle)) {
                    option.innerHTML += ' - Free shipping!'
                }
            })
        })
    }
})();
